export const ItemTypes = {
    WIDGET: 'widget',
  }
  